import { z } from 'zod'
import { Product } from '../../../types'

export const ShopifyProduct = z.object({
  id: z.string().min(1),
  images: z.object({
    nodes: z.array(
      z.object({
        altText: z.string().nullable(),
        url: z.string().min(1)
      })
    )
  }),
  tags: z.array(z.string().min(1)),
  metafields: z.object({
    key: z.string().min(1),
    value: z.string().min(1)
  }).nullable(),
  designerCollaboration: z.object({
    key: z.string().min(1),
    value: z.string().min(1)
  }).nullable(),
  variants: z.object({
    nodes: z.array(
      z.object({
        id: z.string().min(1),
        price: z.object({
          amount: z.string().min(1),
          currencyCode: z.string().min(1)
        }),
        sku: z.string().nullable()
      })
    )
  })
})
export type ShopifyProduct = z.infer<typeof ShopifyProduct>

export const parseShopifyProduct = (input: unknown): Product | null => {
  const product = ShopifyProduct.parse(input)

  if (product == null) {
    return null
  }

  const variant = product.variants.nodes[0]

  const id = product.id
  const variantId = variant.id
  const sku = variant.sku

  let metafields = null
  if (product.metafields) {
    const parsedMetafields = JSON.parse(product.metafields.value)
    metafields = parsedMetafields.reduce((accumulator, field) => {
      accumulator[field.handle] = field
      return accumulator
    }, {})
  }

  const formatUrl = (base: string, i: number) => {
    const url = new URL(base)
    url.searchParams.set('format', 'pjpg')
    //url.searchParams.set('height', [1, 2].includes(i) ? '300' : '617')
    let height = Math.round(window.innerHeight * 0.70).toString();
    url.searchParams.set('height', height);

    return url.toString()
  }

  const { images, alts } = product.images.nodes.reduce<{
    images: string[]
    alts: (string | null)[]
  }>(
    (s, e, i) => ({
      images: [...s.images, formatUrl(e.url, i)],
      alts: [...s.alts, e.altText]
    }),
    { images: [], alts: [] }
  )

  const price = Number(variant.price.amount)

  const currency = variant.price.currencyCode

  const designerCollaboration = product.designerCollaboration?.value || null

  return {
    id,
    sku,
    variantId,
    price,
    currency,
    images,
    alts,
    tags: product.tags,
    metafields: metafields,
    designerCollaboration: designerCollaboration
  }
}
